/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Ukrainian (Ukraine)
export default {
  'paginated-picker.async-select.clear-selection-button.clear-all-selected-items-button-text': 'Скасувати вибір',
  'paginated-picker.async-select.menu-list.error-message.error-message': 'Не вдалось отримати дані',
  'paginated-picker.async-select.menu-list.error-message.retry-message': 'Натисніть, щоб повторити спробу',
  'paginated-picker.async-select.menu-list.loading-message.loading-message': 'Завантаження...',
  'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text': 'Показати більше',
  'paginated-picker.async-select.pagination-details.of-total-count': '{itemsCount} з {totalCount}',
  'paginated-picker.async-select.select.no-options-message.no-options-message': 'Нічого не знайдено',
  'paginated-picker.async-select.select.option.error-message': 'Не вдалось отримати дані',
  'paginated-picker.async-select.select.option.retry-message': 'Натисніть, щоб повторити спробу',
  'paginated-picker.async-select.select.search-placeholder': 'Пошук',
  'paginated-picker.async-select.show-full-list-button.show-full-list-button-text': 'Показати повний список'
};